import { render, staticRenderFns } from "./action-page.vue?vue&type=template&id=afcb46da&scoped=true&"
import script from "./action-page.vue?vue&type=script&lang=js&"
export * from "./action-page.vue?vue&type=script&lang=js&"
import style0 from "./action-page.vue?vue&type=style&index=0&id=afcb46da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afcb46da",
  null
  
)

export default component.exports